import { ADD_CATEGORY, DELETE_CATEGORY, GET_CATEGORY, UPDATE_CATEGORY, GET_ONE_CATEGORY } from '../types';

// const initialState = { list: [], single: null, totalCount: 0 };

const initialState = {
   list: [],
   pagination: {
      limit: 10,
      nextPage: null,
      totalPages: 1,
      currentPage: 1,
      hasNextPage: false,
      previousPage: null,
      totalProducts: 0,
      hasPreviousPage: false,
   },
   single: null,
   totalCount: 0,
};

const reducer = (state = initialState, action) => {
   const { type, payload, totalCount } = action;

   switch (type) {
      case GET_CATEGORY:
         return { ...state, list: payload.data, totalCount: totalCount, pagination: payload.pagination };

      case UPDATE_CATEGORY:
         return {
            ...state,
            list: state.list.map((item) => (item.id === payload.id ? payload : item)),
         };

      case ADD_CATEGORY:
         return {
            ...state,
            list: [payload, ...state.list],
            totalCount: state.totalCount + 1,
         };

      case DELETE_CATEGORY:
         return {
            ...state,
            list: state.list.filter((item) => item.id !== payload.id),
            totalCount: state.totalCount - 1,
         };

      case GET_ONE_CATEGORY:
         return { ...state, single: payload };

      default:
         return state;
   }
};

export default reducer;
